// src/components/CategoryCarousel.jsx
import React from "react";
import Slider from "react-slick";
import { categories } from "./data";

const NextArrow = ({ onClick }) => (
  <button
    type="button"
    className="category-arrow-btn category-arrow-right"
    onClick={onClick}
  >
    <i className="fas fa-chevron-right" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="category-arrow-btn category-arrow-left"
    onClick={onClick}
  >
    <i className="fas fa-chevron-left" />
  </button>
);

const CategoryCarousel = () => {
  const settings = {
    infinite: false,
    speed: 400,
    slidesToShow: 8,
    slidesToScroll: 3,
    swipeToSlide: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 6, slidesToScroll: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 4, slidesToScroll: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3, slidesToScroll: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <div className="category-carousel-wrapper py-4 bg-light mt-5">
      <div className="container position-relative">
        <Slider {...settings}>
          {categories.map((cat) => (
            <div key={cat.id} className="d-flex justify-content-center">
              <button
                type="button"
                className="btn border-0 bg-transparent d-flex flex-column align-items-center category-item"
              >
                <div className="category-circle d-flex align-items-center justify-content-center mb-2">
                  {/* Font Awesome 5: fas + clase del icono */}
                  <i className={`fas ${cat.icon}`} />
                </div>
                <span className="category-label text-uppercase">
                  {cat.label}
                </span>
              </button>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default CategoryCarousel;
